$(function(){
    var item=$(".detect-select-input select");
    if(item.length)
    {
        item=$(item[0]);
        var UpdateShow=function()
        {
            if(item.val())
            {
                $(".controll-show").slideDown();
                $(".not-show").slideUp();
            }else{
                $(".not-show").slideDown();
                $(".controll-show").slideUp();
            }
        };

        $(item).on("change",function(){
            UpdateShow();
        });

        UpdateShow();

    }

});